import { get, post } from "./_base";

const getById = (id) => {
  return get("/group/" + id);
};
const getGroupsByUser = () => {
  return get("/getGroupsByUser");
};
const deleteGroup = (data) => {
  return post("/deleteGroup", data);
};
const createGroup = (data) => {
  return post("/createGroup", data);
};
const renameGroup = (data) => {
  return post("/renameGroup", data);
};

export { getById, getGroupsByUser, deleteGroup, createGroup, renameGroup };
